var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100vw","height":"28rem","overflow-y":"scroll"}},_vm._l((_vm.locklist),function(item,input){return _c('div',{staticClass:"lockbox",on:{"click":function($event){return _vm.$router.push({
     name: 'Merchandise_page',
     params:{ name:item.name}})}}},[_c('img',{attrs:{"src":item.img,"alt":"","srcset":""}}),_c('div',{staticStyle:{"color":"#fff","font-size":"10px","width":"5rem","text-align":"center"}},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }